import ListePartenaires from '../components/ListePartenaires';

function NosPartenaires() {
  return (
    <div
      id="partenaires"
      className="relative bg-cover bg-bottom min-h-[300px] sm:min-h-[400px] md:min-h-[472px]"
      style={{ backgroundImage: "url('/images/bg_skyline.avif')" }}
    >
      <div className="relative top-[30px] sm:top-[40px] md:top-[54px] flex flex-col gap-[20px] sm:gap-[25px] md:gap-[30px] px-4">
        <h3 className="pt-5 pb-3 text-bleu-footer text-center text-2xl sm:text-3xl md:text-4xl font-semibold">
          Nos partenaires
        </h3>
        <div className="pt-4 sm:pt-6 md:pt-8">
          <ListePartenaires/>
        </div>
      </div>
    </div>
  );
}

export default NosPartenaires;